export const PrimaryButton = ({ text, handler, ...props }) => {
  return (
    <button className="primary__button" onClick={handler}>
      {text}
    </button>
  );
};
